
import { Helmet } from "react-helmet";
import { Product } from "@/types/product";

interface ProductHeaderProps {
  product: Product;
}

const generateProductSchema = (product: Product) => ({
  "@context": "https://schema.org/",
  "@type": "Product",
  name: product.name,
  description: product.description,
  offers: {
    "@type": "Offer",
    priceSpecification: {
      eligibleQuantity: {
        value: "100+ units"
      }
    }
  }
});

export default function ProductHeader({ product }: ProductHeaderProps) {
  const schemaMarkup = generateProductSchema(product);

  return (
    <>
      <Helmet>
        <title>{`${product.name} | Auto Parts Export`}</title>
        <meta name="description" content={product.metaDescription} />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <article className="mb-8">
        <h1 className="text-3xl font-bold mb-4">{product.name}</h1>
        <p className="text-gray-600 mb-6">{product.description}</p>
      </article>
    </>
  );
}
